import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  siteMaintenanceWrapper: {
    background: theme?.palette?.primaryBG?.[350],
    margin: "0",
    height: "100vh",
    padding: "0",
    display: "flex",
    flexDirection: "column !important",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  maintenanceImageWrap: {
    textAlign: "center"
  },
  maintenanceText: {
    fontWeight: 600,
    color: theme?.palette?.primaryText?.[100],
    marginBottom: "20px",
    textAlign: "center"
  },
  linearProgress: {
    backgroundColor: theme?.palette?.primaryBG?.[300],
    top: "100px",
    position: "fixed",
    width: "105%",
    zIndex: 10
  }
}));
